// Minimal auth helper: store token in localStorage and provide helper functions
export const TOKEN_KEY = 'fe_admin_token';

export function setToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
}

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function removeToken() {
  localStorage.removeItem(TOKEN_KEY);
}

export async function fetchCurrentUser() {
  const token = getToken();
  if (!token) return null;

  try {
    const res = await fetch('/api/auth', {
      headers: {
        'Content-Type': 'application/json',
        'x-auth-token': token
      }
    });
    if (!res.ok) return null;
    const data = await res.json();
    return data;
  } catch (err) {
    console.error('fetchCurrentUser error', err);
    return null;
  }
}
